import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

export function PageHeader({ Icon, title, description, action }: {
  Icon: LucideIcon
  title: string
  description?: string
  action?: ReactNode
}) {
  return (
    <div className="mb-7 flex items-center justify-between gap-4">
      <div className={`flex ${description ? 'items-start' : 'items-center'} gap-3`}>
        <div className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-brand-gradient text-white shadow-lg">
          <Icon size={22} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {description && <p className="mt-1 text-sm text-gray-600">{description}</p>}
        </div>
      </div>
      {action}
    </div>
  )
}
